import { useState } from "react";
import StyledTable from "../StyledTable/StyledTable";

import "./Accordion.scss";

const createMarkup = (value) => ({ __html: value });

const Accordion = (props) => {
  const [isCollapse, setIsCollapse] = useState(false);
  return (
    <div className="accordion-container">
      <div className="box mb-3 p-3 px-4">
        <div className="d-flex justify-content-between align-items-center mb-0">
          <h5
            className="title"
            dangerouslySetInnerHTML={createMarkup(props.title)}
          />
          <button
            type="button"
            className="btn"
            onClick={() => setIsCollapse(!isCollapse)}
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="#5E514D"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isCollapse ? (
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.333 6.677L3.866 11 3 10.162 8.333 5l5.334 5.162L12.8 11 8.333 6.677z"
                ></path>
              ) : (
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.333 9.323L12.8 5l.867.838L8.333 11 3 5.838 3.866 5l4.467 4.323z"
                ></path>
              )}
            </svg>
          </button>
        </div>

        <StyledTable>
          <div
            className="accordion-content"
            aria-expanded={!isCollapse}
            dangerouslySetInnerHTML={createMarkup(props.children)}
          />
        </StyledTable>
      </div>
    </div>
  );
};

export default Accordion;
